<template>
  <div class="seminar">
    <div class="container">
      <!--------- heading ------------------->
      <v-row flat>
        <v-col cols="12" md="4">
          <span class="heading-1 mobile_size_h1">Seminars</span>
        </v-col>
        <v-col cols="12" md="8">
          <v-card flat class="d-flex justify-end mt-2">
            <!-- <v-btn color="primary">Add new</v-btn> -->

            <v-btn
              color="primary"
              dark
              class="text_style px-7"
              depressed
              @click="AddSeminarDialog()"
            >
              Add new
            </v-btn>

            <v-dialog v-model="addDialog" max-width="650" persistent>
              <v-card class="" v-if="addDialog">
                <addnewseminar :addDialog="addDialog" @close="close" :courses="courses"/>
              </v-card>
            </v-dialog>
          </v-card>
        </v-col>
      </v-row>

      <!--------- search , filter and buttons ------------------->

      <v-row class="d-flex justify-start mt-0">
        <v-col cols="12" md="4" sm="6" class="mt-7">
          <v-card flat>
            <v-text-field
              dense
              outlined
              v-model="search"
              prepend-inner-icon="mdi-magnify"
              label="Search"
              single-line
              @input="searchData()"
            >
            </v-text-field>
          </v-card>
        </v-col>
        <v-col cols="12" md="2" sm="6" class="">
          <v-card
            height="45"
            outlined
            class="px-2 mt-n1 d-flex justify-start align-center"
            style="cursor: pointer"
            @click="filterDialogOpen()"
          >
            <div
              class="d-flex justify-space-between align-center"
              style="width: 100%"
            >
              <div>
                <v-icon>mdi-tune</v-icon>
                <span class="text_style mx-1" style="letter-spacing: 1px"
                  >Filters</span
                >
              </div>

              <div>
                <v-icon>mdi-menu-down</v-icon>
              </div>
            </div>
          </v-card>
        </v-col>
      </v-row>

      <v-dialog v-model="filterDialog" max-width="430" persistent>
        <v-card class="py-5" v-if="filterDialog">
          <v-card-title class="mb-5 d-flex justify-space-between align-center">
            <div class="text-h5"><b> Filters</b></div>
            <div>
              <v-btn text depressed class="pa-0" @click="cleanFilter()">
                <span
                  class="text_style primary--text"
                  style="letter-spacing: 0px"
                  >Clear filters</span
                >
              </v-btn>
              <v-icon class="ml-3" @click="filterDialog = false"
                >mdi-close</v-icon
              >
            </div>
          </v-card-title>
          <v-card-text>
            <v-select
              outlined
              v-model="filterCourse"
              :items="getCourseTaught"
              item-text="Title"
              dense
              hide-details
              label="Course"
              persistent-hint
              multiple
              :menu-props="{ maxHeight: '400' }"
            ></v-select>
            <v-menu
              ref="datarangemenu"
              v-model="datarangemenu"
              :close-on-content-click="false"
              :return-value.sync="date"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="date"
                  append-icon="mdi-calendar"
                  readonly
                  class="my-5"
                  label="Date"
                  dense
                  hide-details
                  outlined
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker v-model="dates" no-title scrollable range>
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="datarangemenu = false">
                  Cancel
                </v-btn>
                <v-btn
                  text
                  color="primary"
                  @click="$refs.datarangemenu.save(date)"
                >
                  OK
                </v-btn>
              </v-date-picker>
            </v-menu>
            <v-select
              outlined
              class="my-5"
              v-model="filterStatus"
              :items="filterStatusArray"
              :menu-props="{ maxHeight: '400' }"
              dense
              hide-details
              label="Status"
              persistent-hint
            >
              <template v-slot:item="{ item }">
                <span v-if="item === 'Active'">
                  <ChangeLanguageComponent :langName="languageObject.Active" />
                </span>
                <span v-else-if="item === 'Inactive'">
                  <ChangeLanguageComponent :langName="languageObject.Inactive" />
                </span>
              </template>
            </v-select>
            <v-select
              outlined
              class="my-5"
              v-model="filterType"
              :items="filterTypeArray"
              :menu-props="{ maxHeight: '400' }"
              item-text="name"
              item-value="Id"
              dense
              hide-details
              label="Online or In Person"
              persistent-hint
            >
            </v-select>
            <!---------------------Type-modalitiy model filter-------------------------------->
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="#646464"
              outlined
              depressed
              class="px-5"
              text
              @click="filterDialog = false"
            >
              <span class="text_style"> Cancel </span>
            </v-btn>
            <v-btn
              color="primary"
              class="px-8 ml-2"
              @click="handleSaveFilter()"
              depressed
            >
              <span class="text_style"> Save Filters </span>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!--------- data table ------------------->
      <v-card class="mt-6" flat outlined>
        <v-data-table
          :headers="headers"
          :loading="tableLoader"
          loading-text="Loading... Please wait"
          :items="GetSeminars?.List"
          :page.sync="page"
          :items-per-page="displayedItemsPerPage"
          @page-count="pageCount = $event"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          @update:sort-by="saveSort"
          @update:sort-desc="saveSort"
          hide-default-footer
        >
          <template v-slot:[`item.index`]="{ index }">
            <b> {{ index + displayedItemsPerPage * (page - 1) + 1 }} </b>
          </template>
          <template v-slot:[`item.TotalStudents`]="{ item }">
            <span class="table_style_two">
              {{ item.TotalStudents }}</span
            >
          </template>
          <template v-slot:[`item.Course.Title`]="{ item }">
            <span class="table_style_two">
              <span v-if="getFlag === 'Japanese'">
                {{ item.Course.Title.replace('Bodytalk Access','ボディートークアクセス') }}
              </span>
              <span v-else>
                {{ item.Course.Title }}
              </span>
            </span>
          </template>
          <template v-slot:[`item.Status`]="{ item }">
            <span class="table_style_two">
              <span v-if="item.Status === 'Active'">
                <ChangeLanguageComponent :langName="languageObject.Active" />
              </span>
              <span v-else-if="item.Status === 'Inactive'">
                <ChangeLanguageComponent :langName="languageObject.Inactive" />
              </span>
            </span>
          </template>
          <template v-slot:[`item.Location`]="{ item }">
            <span class="table_style_two" v-if="item.Location">
              {{ item.Location?.LocationName }}, {{ item.Location?.City }},
              {{ item.Location?.Country }}
              <span v-if="item.AvailableOnline" class=""
                >and <v-icon>mdi-youtube-tv</v-icon> Online</span
              >
            </span>
            <span class="table_style_two" v-else> Online </span>
          </template>
          <template v-slot:[`item.SeminarDate`]="{ item }">
            <div>
              <div>
                <span class="table_style_two">
                  {{ item.SeminarDateAndTimes[0].Date?.split("T")[0] }} - 
                </span>
              </div>
              <div>
                <span class="table_style_two">
                  {{ item.SeminarDateAndTimes[item.SeminarDateAndTimes?.length - 1].Date.split("T")[0] }}
                </span>
              </div>
            </div>
          </template>

          <!-- <div>
            <span class="table_style_two">
              {{ checkDate(item.ModifiedDate) }}
            </span>
          </div> -->

          <template v-slot:[`item.actions`]="{ item }">
            <v-menu
              transition="scroll-y-transition"
              offset-y
              color="transparent"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-icon color="A1A1A6" v-bind="attrs" v-on="on">
                  mdi-dots-horizontal
                </v-icon>
              </template>
              <v-card flat>
                <v-list class="px-3 pt-1" color="transparent">
                  <v-btn
                    depressed
                    color="transparent"
                    block
                    class="d-flex justify-start"
                    @click="seminarDialogOpen(item.Id)"
                  >
                    <v-icon color="#646464">mdi-open-in-new</v-icon>
                    <span class="ml-4 text_style">See Seminar</span>
                  </v-btn>
                </v-list>
                <v-list class="px-3 pt-1" color="transparent">
                  <v-btn
                    depressed
                    color="transparent"
                    block
                    class="d-flex justify-start"
                    @click="seeStudents(item)"
                  >
                    <v-icon color="#646464">mdi-account</v-icon>
                    <span class="ml-4 text_style">See Students</span>
                  </v-btn>
                </v-list>

                <v-list class="px-3 pt-1" color="transparent">
                  <v-btn
                    depressed
                    color="transparent"
                    block
                    class="d-flex justify-start"
                    @click="editDialogSeminar(item)"
                  >
                    <v-icon color="#646464">mdi-pencil</v-icon>
                    <span class="ml-4 text_style">Edit</span>
                  </v-btn>
                </v-list>
                <v-list class="px-3 pt-1" color="transparent">
                  <v-btn
                    depressed
                    color="transparent"
                    block
                    class="d-flex justify-start"
                    @click="deleteDialogSeminar(item.Id)"
                  >
                    <v-icon color="#646464">mdi-delete</v-icon>
                    <span class="ml-4 text_style"><ChangeLanguageComponent :langName="languageObject.Delete"/></span>
                  </v-btn>
                </v-list>
              </v-card>
            </v-menu>
          </template>
        </v-data-table>
      </v-card>
      <v-card
        flat
        class="pagination-container my-9 d-flex justify-end align-center"
      >
        <div class="d-flex">
          <span class="text_transform pa-0 ma-0">Per page : </span>
          <v-card flat width="100" class="mx-5">
            <v-select
              :items="ItemsPerPageItems"
              label="Items per page"
              v-model="itemsPerPage"
              @change="handleChangePageSize"
            ></v-select>
          </v-card>
        </div>
        <v-pagination
          v-model="page"
          :length="pageCount"
          :total-visible="5"
          @input="fetchData"
        ></v-pagination
      ></v-card>
      <v-dialog v-model="seminardialog" max-width="700" persistent>
        <v-card class="pa-3" v-if="seminardialog">
          <div class="d-flex justify-end">
            <v-icon @click="seminardialog = false">mdi-close</v-icon>
          </div>
          <div>
            <seeseminar :Id="setId" />
          </div>
          <!-- <v-card-actions class="px-11">
            <v-btn
              color="primary"
              class="my-6 py-6"
              depressed
              to="/checkout"
              block
            >
              ADD TO CART
            </v-btn>
          </v-card-actions> -->
          <div
            class="px-11 lightgrey d-flex justify-center pb-9"
            style="font-size: 12px; text-align: center"
          >
            By clicking this button, you submit your information to the webinar
            organizer, who will use it to communicate with you regarding this
            event and their other services.
          </div>
        </v-card>
      </v-dialog>
      <!----------Edit dialog------------------>
      <v-dialog v-model="editdialog" persistent max-width="600">
        <v-card v-if="editdialog">
          <div>
            <editseminar
              :EditSeminarDialog="editdialog"
              @close="close"
              :setDataEditSeminar="setDataEditSeminar"
              :courses="courses"
            />
          </div>
        </v-card>
      </v-dialog>
      <!----------Delete dialog------------------>
      <v-dialog v-model="dialog" persistent max-width="400">
        <v-card>
          <v-card-title class="text-h5"> Warning </v-card-title>
          <v-card-text
            class="index_span_2_style"
            style="height: 100px; font-size: 22px"
            >Are you sure you want to delete?</v-card-text
          >
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" text @click="dialog = false">
              Cancel
            </v-btn>
            <v-btn color="red darken-1" text @click="DdialogClose()">
              confirm
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import addnewseminar from "../../components/Seminar/addnewseminar.vue";
import editseminar from "../../components/Seminar/editseminar.vue";
import seeseminar from "../../components/Seminar/seeseminar.vue";
import ChangeLanguageComponent from "../../components/HomePage/ChangeLanguage.Component.vue";
import languageObject from "../../utils/index";
import { mapGetters } from "vuex";
export default {
  components: {
    addnewseminar,
    editseminar,
    seeseminar,ChangeLanguageComponent,
  },
  data() {
    return {
      languageObject,
      setDataEditSeminar: null,
      setId: null,
      datarangemenu: false,
      dates: [],
      items: [],
      filtersArray: [],
      addDialog: false,
      search: "",
      filterCourse: [],
      filterCourseArray: ["[course_names]"],
      filtercity: [],
      filtercityArray: ["[city_names]"],
      filtercountry: [],
      filtercountryArray: ["[Country_name]"],
      filterseminar: [],
      filterseminarArray: ["YES", "NO"],
      filtermonth: [],
      filtermonthArray: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ],
      filterStatus: "",
      filterStatusArray: ["Active", "Inactive"],
      filterType: "",
      filterTypeArray: [
        { name: "Online", Id: 2 },
        { name: "In-person", Id: 1 },
      ],
      isFiltering: false,
      filterDialog: false,
      ItemsPerPageItems: [10, 50, 100, 200, "All"],
      page: 1,
      filters: [],
      pageCount: 1,
      pageSize: 10,
      itemsPerPage: 10,
      Permission: {},
      SuccessToast: false,
      ErrorToast: false,
      uploadfiledialog: false,
      createnewgroupdialog: false,
      editdialog: false,
      seminardialog: false,
      btnloader: false,
      SeminarFilterListByUserId: [],
      courses: [],
      tableLoader: false,
      dialog: false,
      headers: [
        { text: "#", value: "index" },
        { text: "Start Date/End Date", value: `SeminarDate`, sortable: true},
        { text: "Course", value: "Course.Title" },
        { text: "Location", value: "Location", sortable: false },
        { text: "Total Students", value: "TotalStudents", sortable: false },
        // { text: "Start Date", value: `SeminarDateAndTimes`, sortable: true, sortMethod: this.sortSeminarDates },
        { text: "Status", value: "Status", sortable: false },

        { text: "", value: "actions", sortable: false },
      ],
      filtersArray: [
        {
          Key: "CreatedBy",
          Value: null,
        },
      ],
      seachTimer: 0,
      sortBy: '',  // default sort column
      sortDesc: false  // default sort direction
    };
  },
  computed: {
    ...mapGetters([
      "GetSeminars",
      "GetCourse",
      "GetLocation",
      "GetUser",
      "getFlag",
      "GetFilterOptionsData",
      "getCourseTaught",
      "getMembershipByUserId"
    ]),
    displayedItemsPerPage() {
      return this.itemsPerPage === "All"
        ? this.GetSeminars.List.length
        : this.itemsPerPage;
    },
    date() {
      return this.dates.join(" to ");
    },
  },
  mounted() {
    const obj = {
      id: this.GetUser?.Id,
    };
    this.$store.dispatch("GetMembershipByUserId", obj);
    this.loadSortSettings();
    this.filtersArray[0].Value = this.GetUser?.Id;
    this.page = this.$store.state.seminarPageno || this.page;
    this.itemsPerPage = this.$store.state.seminarItemsPerPage || this.itemsPerPage;
    this.filterCourse = this.$store.state.seminarCourseName || []
    this.filterType = this.$store.state.seminarType
    this.filterStatus = this.$store.state.seminarStatus
    this.dates = this.$store.state.seminarDate || []
    if(this.filterCourse.length > 0 || this.filterType || this.filterStatus || this.dates.length > 0){
      this.handleSaveFilter()
    }else{
      this.fetchData();
    }
    this.fetchCourses();
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (!from.path.startsWith("/students")) {
        vm.$store.state.seminarCourseName = null;
        vm.$store.state.seminarType = null;
        vm.$store.state.seminarStatus = null;
        vm.$store.state.seminarDate = null;
        vm.$store.state.seminarItemsPerPage = null;
        vm.$store.state.seminarPageno = null;
        localStorage.removeItem("sortBy");
        localStorage.removeItem("sortDesc");
      }
    });
  },
  methods: {
    // Save sort settings to localStorage
    saveSort() {
      localStorage.setItem("sortBy", this.sortBy);
      localStorage.setItem("sortDesc", this.sortDesc);
    },
    // Load sort settings from localStorage
    loadSortSettings() {
      const savedSortBy = localStorage.getItem("sortBy");
      const savedSortDesc = localStorage.getItem("sortDesc");

      if (savedSortBy) this.sortBy = savedSortBy;
      if (savedSortDesc !== null) this.sortDesc = JSON.parse(savedSortDesc);
    },
    async fetchCourses() {
      this.$store.dispatch("GetCourseTaught", this.GetUser?.Id);
      // await this.$store.dispatch("GetLiveCourse", {
      //   page: 1,
      //   pageSize: "All",
      //   filters: [],
      // });
},
    seeStudents(item) {
      this.$store.state.courseName = item.Course.Title;
      this.$router.push(`/students/${item.Id}`);
    },
    searchData() {
      clearTimeout(this.seachTimer);
      this.seachTimer = setTimeout(() => {
        this.page=1
        this.fetchData();
      }, 700);
    },
    seminarDialogOpen(userInfoId) {
      // this.seminardialog = true;
      // this.setId = userInfoId;
      const obj = {
        seminarId: userInfoId,
        id: this.GetUser?.Id || 0,
      };
      this.$store.dispatch("GetSeminarBySeminarIdAndUserId", obj).then(() => {
        this.$store.dispatch("GetUserEligibleForSeminar", obj).then(() => {
          // this.$router.push({ path: `/courses/${userInfoId}` });
          const url = `/courses/${userInfoId}`;
          window.open(url, "_blank");
        });
      });
    },
    async handleSaveFilter() {
      this.$store.state.seminarCourseName = this.filterCourse
      this.$store.state.seminarType = this.filterType
      this.$store.state.seminarStatus = this.filterStatus
      this.$store.state.seminarDate = this.dates
        this.filtersArray = [
          {
            Key: "CreatedBy",
            Value: this.GetUser?.Id
          }]
        this.filterDialog = false;
        this.isFiltering = true;
        if (this.filterCourse.length > 0) {
          this.filtersArray.push({
            Key: "Course",
            Value: this.filterCourse.join(","),
          });
        }
        if (this.filterStatus) {
          this.filtersArray.push({
            Key: "Status",
            Value: this.filterStatus,
          });
        }
        if (this.filterType) {
          this.filtersArray.push({
            Key: "type",
            Value: this.filterType,
          });
        }
        if (this.dates.length > 0) {
          let dates = [...this.dates];

          if (dates.length > 1) {
            dates.sort((a, b) => {
              const dateA = new Date(a);
              const dateB = new Date(b);
              return dateA - dateB;
            });
          }

          this.filtersArray.push({
            Key: "Date",
            Value: dates.join(","),
          });
        }
        try {
          await this.fetchData();
        } catch (e) {}
      this.isFiltering = false;
      this.filterDialog = false;
    },
    async filterDialogOpen() {
      this.filterDialog = true;
    },
    AddSeminarDialog(){
      if(this.getMembershipByUserId.Data?.MembershipStatus==0){
        this.$swal.fire({
          position: "center",
          icon: "warning",
          title: "Expired instructors cannot add or edit seminars",
          showConfirmButton: false,
          timer: 3000,
          toast: false,
        });
      } else {
        this.addDialog = true;
      }
    },
    editDialogSeminar(data) {
      if(this.getMembershipByUserId.Data?.MembershipStatus==0){
        this.$swal.fire({
          position: "center",
          icon: "warning",
          title: "Expired instructors cannot add or edit seminars",
          showConfirmButton: false,
          timer: 3000,
          toast: false,
        });
      } else {
        this.setDataEditSeminar = data;
        this.editdialog = true;
      }
    },
    deleteDialogSeminar(id) {
      this.dialog = true;
      this.setId = id;
    },
    async fetchData() {
      this.$store.state.seminarPageno = this.page
      this.tableLoader = true;
      const payload = {
        search: this.search,
        pageSize: this.itemsPerPage,
        page: this.page,
        filters: JSON.stringify(this.filtersArray),
      };
      await this.$store.dispatch("GetAllSeminars", payload).then((res) => {
        this.tableLoader = false;
        if (this.itemsPerPage !== "All") {
          const totalRecords = this.GetSeminars?.totalRecords;
          this.pageCount = Math.ceil(totalRecords / this.itemsPerPage);
          // this.pageCount = Math.ceil(
          //   this.GetSeminars.List.length / this.itemsPerPage
          // );
        } else {
          this.pageCount = 1;
        }
        //this.$store.dispatch("GetFiltersOptionsData", this.GetUser.Id);
      });
    },
    hasDatePassed(dates) {
      return dates.find((date) => {
        const seminarDate = new Date(date.Date);
        const currentDate = new Date();
        currentDate.setHours(0, 0, 0, 0);
        return seminarDate >= currentDate;
      });
    },

    handleChangePageSize() {
      this.page = 1;
      this.$store.state.seminarItemsPerPage = this.itemsPerPage
      this.fetchData();
    },

    DdialogClose() {
      const obj = {
        Id: this.setId,
      };
      this.$store.dispatch("DeleteSeminar", obj).then(() => {
        this.dialog = false;
        this.fetchData();
        this.ErrorToast = true;
        setTimeout(() => {
          this.ErrorToast = false;
        }, 1500);
      });
    },
    goBack() {
      this.isHidden = false;
    },
    send() {
      setTimeout(() => {
        this.btnloader = true;
      }, 100);
      setTimeout(() => {
        this.editdialog = false;
        this.seminardialog = false;
        this.btnloader = false;
        this.uploadfiledialog = false;
        this.createnewgroupdialog = false;
        this.SuccessToast = true;
      }, 2000);
      setTimeout(() => {
        this.SuccessToast = false;
      }, 3000);
    },
    close() {
      this.addDialog = false;
      this.SuccessToast = false;
      this.ErrorToast = false;
      this.editdialog = false;
      this.fetchData();
    },
    cleanFilter() {
      this.filterCourse = [];
      this.filterStatus = '';
      this.filterType = '';
      this.dates = [];
    },
  },
};
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: #e0e0e0;
}
.pagination-container {
  flex-direction: column;
}
@media (min-width: 576px) {
  .pagination-container {
    flex-direction: row;
  }
}
</style>
